import { render, staticRenderFns } from "./scoreAnalysisInfo.vue?vue&type=template&id=f000d512&scoped=true&"
import script from "./scoreAnalysisInfo.vue?vue&type=script&lang=js&"
export * from "./scoreAnalysisInfo.vue?vue&type=script&lang=js&"
import style0 from "./scoreAnalysisInfo.vue?vue&type=style&index=0&id=f000d512&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f000d512",
  null
  
)

export default component.exports